import { useMutation } from "@tanstack/react-query";
import axios from "axios";

const postRequestContactForm = async (formData: any) => {
  const response = await axios.post(`/api/request-contact`, formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const useRequestContactFormMutation = () => {
  return useMutation({
    mutationFn: postRequestContactForm,
  });
};
